// Copyright (c) Bentley Systems
import { useCallback } from "react";
import { useToaster } from "@itwin/itwinui-react";

export const STATUS = {
  POSITIVE: "positive",
  NEGATIVE: "negative",
  WARNING: "warning",
  INFORMATIONAL: "informational",
};

export const ACTION = {
  CREATE: "create",
  UPDATE: "update",
  DELETE: "delete",
};

export const MESSAGES = {
  [ACTION.CREATE]: "Record was successfully created.",
  [ACTION.UPDATE]: "Record was successfully updated.",
  [ACTION.DELETE]: "Record was successfully deleted.",
  ["UNAUTHORIZED"]: "User is not authorized to perform this action.",
  ["NOT_FOUND"]: "Unable to find the requested resource.",
  ["NEGATIVE_DEFAULT"]: "Operation was unsuccessful.",
  ["POSITIVE_DEFAULT"]: "Operation was successful.",
};

export const useToastNotificationService = () => {
  const toaster = useToaster(); // ✅ Works because ToastInitializer ensures it's available

  const showToast = useCallback(({
    status,
    action,
    message = "",
  }: {
    status: string;
    action?: string;
    message?: string;
  }) => {
    if (!message) {
      if (status === STATUS.NEGATIVE) {
        message = MESSAGES.NEGATIVE_DEFAULT;
      } else if (action) {
        message = MESSAGES[action];
      }else if (status === STATUS.POSITIVE) {
        message = MESSAGES.POSITIVE_DEFAULT;
      }else{
        throw new Error(`Default message not implemented for action '${action}' and '${status}'.`);
      }
    }

    switch (status) {
      case STATUS.POSITIVE:
        toaster.positive(message);
        break;
      case STATUS.NEGATIVE:
        toaster.negative(message, { type: "persisting" });
        break;
      case STATUS.WARNING:
        toaster.warning(message);
        break;
      case STATUS.INFORMATIONAL:
        toaster.informational(message);
        break;
      default:
        toaster.informational("An unknown status occurred.");
    }
  }, [toaster]);

  return { showToast };
};